import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  //公共state对象，存储所有组件状态
  state: {   
      user:{
        username:'',
        token:''
      }
    
  },
  //唯一取值方法，计算属性
  getters: {
    getUser(state){
      return state.user
    }
  },
  mutations: {
    setUser(state,user){
      state.user = user
    },
    setToken(state, token) {
      state.token = token;
    }
  },
  actions: {

  },
  modules: {
  }
})
